import { Link } from 'react-router-dom';
import { categories } from '@/mocks/tvshows';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-100" aria-label="剧集分类">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            剧集分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型找到你想看的电视剧</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-5 md:p-6 hover:bg-primary-500 transition-all duration-300"
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-background-50/20 transition-colors mb-3">
                  <i className={`${cat.icon} text-2xl text-primary-500 group-hover:text-background-50 transition-colors`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-background-50 transition-colors whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400 group-hover:text-background-50/70 transition-colors mt-1">
                  {cat.count} 部剧集
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}